import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { AuthService } from '../../services/auth.service';
import { ProductosService } from '../../services/productos.service';

@Component({
  selector: 'app-clientes',
  templateUrl: './clientes.component.html',
  styleUrls: ['./clientes.component.scss']
})
export class ClientesComponent implements OnInit {
  todos: any;
  lista: any;
  distribuidores = [];
  clientes = [];
  descuentoPorcent: number;
  distSelected: string;
  constructor(private authSvc: AuthService,
              private productoSvc: ProductosService) { }

  ngOnInit(): void {
    this.authSvc.listaClientes()
                .subscribe(res => {
                  this.lista = res;
                  this.todos = res;
                });
  }

  dist(idDist: string){
    // console.log(idDist); 
    this.distSelected = idDist;   
  }

  descuentoDistribuidor(){
    if (this.descuentoPorcent === undefined) {
      Swal.fire('Debe ingresar el porcentaje');
      return;
    }
    Swal.fire({
      title: 'Está seguro?',
      text: "Se va a aplicar un" + " " + this.descuentoPorcent + "% de descuento a este distribuidor",
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si, aplicar!'
    }).then((result) => {
      if (result.isConfirmed) {
        this.productoSvc.asignarDescuentoDistribuidor(this.distSelected, this.descuentoPorcent).then(() => {
          Swal.fire(
            'Hecho!',
            'Descuento asigmado correctamente.',
            'success'
          );
        });        
      }
    })
  }

  desactivar(idUser: string){
    Swal.fire({
      title: 'Está seguro?',
      text: 'El usuario quedará activo como distribuidor!',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si, aceptar!'
    }).then((result) => {
      if (result.isConfirmed) {
        this.authSvc.desactivarDistribuidor(idUser);
        Swal.fire(
          'Activado!',
          'El usuario esta registrado como distribuidor.',
          'success'
        );
      }
    });
  }

  activar(idUser: string){
    Swal.fire({
      title: 'Está seguro?',
      text: 'El usuario quedará activo como distribuidor!',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si, aceptar!'
    }).then((result) => {
      if (result.isConfirmed) {
        this.authSvc.aceptarDistribuidor(idUser);
        Swal.fire(
          'Activado!',
          'El usuario esta registrado como distribuidor.',
          'success'
        );
      }
    });
  }

  filtrar(event: string){
    if (event) {
      // tslint:disable-next-line: forin
      for (const key in this.lista){
        if (this.lista[key].tipo === 'Distribuidor') {
          this.distribuidores.push(this.lista[key]);
        }
        if (this.lista[key].tipo === 'Cliente') {
          this.clientes.push(this.lista[key]);
        }
      }
      if (event === 'distribuidores') {
        this.lista = this.distribuidores;
      }
      if (event === 'clientes') {
        this.lista = this.clientes;
      }
      if (event === 'todos') {
        this.lista = this.todos;
      }
    }
  }

}
